import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import styles from "./allAssessments.module.css";

const fetchCompanyData = async () => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const raw = JSON.stringify({ "useremail": "" });
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };
  try {
    const response = await fetch("https://casaahaanahotels.com/search_company_data", requestOptions);
    return await response.json();
  } catch (error) {
    console.error("Error fetching company data:", error);
    return [];
  }
};

const fetchDepartmentData = async () => {
  try {
    const response = await axios.post("https://casaahaanahotels.com/get_master_assessment_type", {});
    return response.data;
  } catch (error) {
    console.error("Error fetching department data:", error);
    return [];
  }
};

const ReviewByCompany = () => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [selectedDepartmentCode, setSelectedDepartmentCode] = useState("");
  const [searchUserEmail, setSearchUserEmail] = useState("");
  const [adminCodeForEmail, setAdminCodeForEmail] = useState("");
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const navigate = useNavigate();

  // Load assessments with filters
  const loadAssessments = async (filters) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://casaahaanahotels.com/new_list_assessments",
        filters,
        { headers: { "Content-Type": "application/json" } }
      );
      const result = Array.isArray(response.data?.result) ? response.data.result : [];
      setAssessments(result);

      if (result.length === 0) {
        setError("No assessments have been created yet!");
      } else {
        setError("");
      }
    } catch (err) {
      console.error("Error fetching assessments:", err);
      setError("Failed to fetch assessments.");
    } finally {
      setLoading(false);
    }
  };

  // On mount, load all assessments (with empty filters)
  useEffect(() => {
    loadAssessments({
      useremail: "",
      companycode: "",
      departmentcode: ""
    });
  }, []);

  // Fetch company data
  useEffect(() => {
    let isMounted = true;
    const loadCompanies = async () => {
      const data = await fetchCompanyData();
      if (isMounted) {
        setCompanies(data);
      }
    };
    loadCompanies();
    return () => { isMounted = false; };
  }, []);

  // Fetch department data
  useEffect(() => {
    let isMounted = true;
    const loadDepartments = async () => {
      const data = await fetchDepartmentData();
      if (isMounted) {
        setDepartments(data);
      }
    };
    loadDepartments();
    return () => { isMounted = false; };
  }, []);

  // Handle search button click: call API with selected filters
  const handleSearch = () => {
    loadAssessments({
      useremail: searchUserEmail.trim(),
      companycode: selectedCompanyCode,
      departmentcode: selectedDepartmentCode
    });
  };

  const [assessmentData, setAssessmentData] = useState([]);

  const fetchLandingPage = async () => {
    const userCode = adminCodeForEmail;
    if (!userCode) {
      console.error('No userCode found in localStorage');
      return;
    }

    try {
      const response = await fetch('https://casaahaanahotels.com/sb_getlandingpage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          usercode: userCode
        })
      });

      const data = await response.json();
      setAssessmentData(data.user_data);
      console.log('Landing page data:', data);
      return data;
    } catch (error) {
      console.error('Error fetching landing page:', error);
      throw error;
    }
  };

  useEffect(() => {
    fetchLandingPage();
  },[])

  // getting value from assessmentData;
  const {
    AssessmentType,
    companyname,
    aadminpageoffers,
    contactphone,
    adminemail
  } = assessmentData[0] || {};

  console.log('Assessment Type:', assessmentData[0]);

  localStorage.setItem('AssessmentTypelist', AssessmentType)
  localStorage.setItem('aadminpageofferslist', aadminpageoffers)

  const sendEmail = async (driverEmail,driverName, starScore, companyName,contact_phone,admin_email) => {
    // show_score();
    const useremail = driverEmail;
    const drivername = driverName;
    const stars = starScore;
    // const Assessment_Type = localStorage.getItem("AssessmentTypelist");
    const formattedAssessmentType = localStorage.getItem("AssessmentTypelist");
    const Assessment_Type = formattedAssessmentType
  ? formattedAssessmentType.charAt(0).toUpperCase() + formattedAssessmentType.slice(1)
  : "";
    const company_name = companyName;
    const aadminpage_offers = localStorage.getItem("aadminpageofferslist");
    

    // if (!stars || stars === "0") {
    //   show_score();
    //   return false;
    // }

    let sendmail;
    if (parseInt(stars, 10) >= 3) {
      // 3 or more
      sendmail = `<body style="font-family:Arial,sans-serif;background-color:#f4f4f4;margin:0;padding:0">
        <div class="container" style="width:96%;margin:30px auto;background:#fff;padding:20px;box-shadow:0 0 15px rgba(0,0,0,.2);border-radius:8px">
          <div class="header" style="text-align:center">
            <img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" alt="Star Behaviors Logo" style="width:auto;max-width:auto;height:100px;display:block;margin:0 auto">
          </div>
          <div class="content" style="margin-top:20px;line-height:1.6">
            <h2 style="text-align:center">${Assessment_Type}</h2>
            <h2 style="text-align:center">Assessment Completed - Congratulations on Your Achievement!</h2>
            <p style="font-size: 16px;">Dear ${drivername},</p>
            <p style="font-size: 16px;">We're thrilled to inform you that you've successfully completed [Part 1] of the Star Behaviors Assessment. Your journey towards a fulfilling career has taken a significant leap forward!</p>
            <center><h3>Your Star Score:</h3><img src="https://starbehaviors.com/uploadimage/${stars}.png"></center>
            <p style="font-size: 16px;">Your <b>${stars}-star rating</b>signifies your good alignment with the required behavioral traits for this position, indicating a high likelihood of long-term satisfaction and fulfillment in this career. Individuals receiving a ${stars}-star rating are normally well-suited for both formal (e.g., post-secondary training) and informal (on-the-job) training programs.</p>
            <p style="font-size: 16px;">Whether you're entering the job market for the first time, considering a career change, or already established in this field, you can confidently pursue this profession. Prospective employers are likely to be eager to explore training and employment opportunities with candidates of your caliber.</p>
            <h3>What This Means for Your Career</h3>
            <p style="font-size: 16px;">Receiving a ${stars}-star rating places you in an enviable position. It signifies that you're exceptionally well-suited for a range of professional development opportunities, encompassing both formal education (such as post-secondary training programs) and practical, on-the-job experiences.</p>
            <p style="font-size: 16px;">Whether you're stepping into the job market for the first time, contemplating a career shift, or furthering your journey in your current field, this score empowers you to confidently advance. Employers are always on the lookout for candidates of your caliber and potential, making you a desirable prospect for training and employment opportunities.</p>
            <p style="font-size: 16px;">At Star Behaviors, LLC, we take pride in guiding individuals towards careers that not only match their skills and interests but also ignite their passion. Thank you for trusting us on this pivotal journey. Remember, your success isn't just written in the stars—it's also shaped by your dedication and our support.</p>
            <p style="font-size: 16px;">Wishing you a stellar career ahead!</p>
            <p>Warm regards,</p>
            <p style="font-size: 16px;">TJ Graff<br>CEO<br>Star Behaviors, LLC</p>
          </div>
          <div class="footer" style="text-align:center;margin-top:20px;font-style:italic"><b>Powered by Star Behaviors.</b></div>
        </div>
      </body>`;
    } else {
      // <3
      sendmail = `<body style="font-family:Arial,sans-serif;background-color:#f4f4f4;margin:0;padding:0">
        <div class="container" style="width:96%;margin:30px auto;background:#fff;padding:20px;box-shadow:0 0 15px rgba(0,0,0,.2);border-radius:8px">
          <div class="header" style="text-align:center">
            <img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" 
              alt="Star Behaviors Logo" 
              style="width:auto;max-width:100%;height:100px;display:block;margin:0 auto">
          </div>
          <div class="content" style="margin-top:20px;line-height:1.6">
            <h2 style="text-align:center">${Assessment_Type}</h2>
            <h2 style="text-align:center">Assessment Completed</h2>
            <p style="font-size: 16px;">Dear ${drivername},</p>
            <p style="font-size: 16px;">
              We're thrilled to inform you that you've successfully completed <b>[Part 1]</b> of the Star Behaviors Assessment. 
              Your journey towards a fulfilling career has taken a significant leap forward!
            </p>
            <center>
              <h3>Your Star Score:</h3>
              <img src="https://starbehaviors.com/uploadimage/${stars}.png" 
                alt="Star Score" 
                style="display:block;margin:auto;max-width:100%;">
            </center>
            <p style="font-size: 16px;">
              The <b>Star Behaviors Behavioral Assessment</b> you've just completed is built upon an extensive job analysis 
              involving individuals who have achieved lasting success and contentment in this career. Our research has 
              identified numerous behaviors critical for your sustained happiness in this field.<br><br> 
              Research findings indicate that individuals scoring <b>${stars}</b> stars or lower are unlikely to experience 
              long-term fulfillment or happiness in this profession.
            </p>
            <p style="font-size: 16px;">
              Our partners are primarily interested in exploring training and employment opportunities with candidates 
              who score <b>3, 4, or 5 stars</b>. 
              

              <br><br> 
              To ensure your enduring job satisfaction, we encourage you to consider completing one of our various 
              other compatibility self-assessments to find the career that is a perfect fit for you!
            </p>
            <p style="font-size: 16px;">
              Warm regards,<br><br>
              <b>TJ Graff</b><br> 
              CEO<br> 
              Star Behaviors, LLC
            </p>
          </div>
          <div class="footer" style="text-align:center;margin-top:20px;font-style:italic">
            <b>Powered by Star Behaviors.</b>
          </div>
        </div>
      </body>`;
    }

    const subject = 'Star Behaviors Assessment Results';
    const name = drivername;
    const mailApiUrl = 'https://bakemywords.com/mailchimp/sendmail.php';
    const recipients = [useremail]; // Send to both
  
    for (const email of recipients) {
      const requestBody = {
        email,
        name,
        subject,
        message: sendmail
      };
  
      try {
        const response = await fetch(mailApiUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody)
        });
  
        console.log(`Email sent to: ${email}`);
      } catch (error) {
        console.error(`Error sending email to ${email}:`, error);
      }
    }
  };

  // When assessments change, reset to first page
  useEffect(() => {
    setCurrentPage(1);
  }, [assessments.length]);

  // Pagination logic
  const totalPages = Math.ceil(assessments.length / itemsPerPage);
  const paginatedAssessments = assessments.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Helper to generate pagination numbers with ellipsis
  const getPagination = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }
    return pages;
  };

  const handlePageClick = (page) => {
    if (page === '...') return;
    setCurrentPage(page);
  };

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Assessment List</h2>

      <div className={styles.filterContainer}>
        {/* Company dropdown */}
        <select
          className={styles.companyDropdown}
          value={selectedCompanyCode}
          onChange={(e) => setSelectedCompanyCode(e.target.value)}
        >
          <option value="">All Companies</option>
          {companies.map((company) => (
            <option key={company.id} value={company.admincode}>
              {company.companyname}
            </option>
          ))}
        </select>

        {/* Search button */}
        <button onClick={handleSearch} className={styles.searchButton}>
          Search
        </button>
      </div>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : error ? (
        <p className={styles.errorText}>{error}</p>
      ) : (
        <div className={styles.tableWrapper}>
          <table className={styles.assessmentTable}>
            <thead>
              <tr>
                <th>Driver Name</th>
                <th>Email</th>
                <th>Company Name</th>
                <th>Star Score</th>
                <th>Completed Date</th>
                <th>Validity</th>
                <th>View</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedAssessments.map((assessment, idx) => {
                if (assessment?.driverid && assessment?.score != null) {
                  const firstName = assessment.driver_details?.FirstName || "N/A";
                  const lastName = assessment.driver_details?.LastName || "N/A";
                  const driverName = `${firstName} ${lastName}`;
                  const driverEmail = assessment.driver_details?.DriverEmail || "N/A";
                  const companyName = assessment.company_details?.companyname || "N/A";
                  const contact_phone = assessment.company_details?.contactphone || "N/A";
                  const starScore = assessment.score;
                  const completedDate = new Date(assessment.timestamp).toLocaleDateString("en-US");
                  const validityDate = new Date(assessment.validity).toLocaleDateString("en-US");
                  const assessmentId = assessment.assessementid;
                  const admin_code_reg = assessment?.driver_details?.company_details?.admincode;
                  const admin_email = assessment?.driver_details?.company_details?.adminemail;
                  return (
                    <tr key={idx}>
                      <td title={driverName}>{driverName}</td>
                      <td title={driverEmail}>{driverEmail}</td>
                      <td title={companyName}>{companyName}</td>
                      <td>
                        <img
                          src={`https://starbehaviors.com/uploadimage/${starScore}.png`}
                          alt={`Score: ${starScore}`}
                          className={styles.scoreImage}
                        />
                      </td>
                      <td>{completedDate}</td>
                      <td>{validityDate}</td>
                      <td>
                        <button
                          className={styles.viewButton}
                          onClick={() => navigate(`/admin/search-assessments/${assessmentId}`)}
                        >
                          View
                        </button>
                      </td>
                      <td>
                        <button
                          className={styles.viewButton}
                          onClick={() => {
                            setAdminCodeForEmail(admin_code_reg);
                            sendEmail(driverEmail,driverName, starScore, companyName,contact_phone,admin_email)}
                          }
                        >
                          Send Email
                        </button>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </table>
          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className={styles.pagination} style={{ marginTop: '16px', display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center' }}>
              <button onClick={handlePrev} disabled={currentPage === 1} className={styles.pageButton}>Prev</button>
              {getPagination().map((page, idx) => (
                <button
                  key={idx}
                  onClick={() => handlePageClick(page)}
                  disabled={page === '...'}
                  className={
                    page === currentPage
                      ? styles.activePageButton
                      : styles.pageButton
                  }
                  style={{ minWidth: 32 }}
                >
                  {page}
                </button>
              ))}
              <button onClick={handleNext} disabled={currentPage === totalPages} className={styles.pageButton}>Next</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ReviewByCompany;
